
<app-home-listing [NewlyAdded]="NewlyAddedParentObject" [IsLoading]="IsLoading"></app-home-listing>
@if (MostPopularPlaces != undefined && MostPopularPlaces.length != 0) {
  <section class="fullwidth border-bottom margin-top-0 margin-bottom-0 padding-top-20 padding-bottom-10"
    data-background-color="rgb(247, 247, 247)">
    <div class="container" >
      <div class="row">
        <div class="col-md-12">
          <h3 class="headline centered margin-bottom-10 margin-top-0">
            <span> Properties In Most Popular Cities </span>
          </h3>
        </div>
        @for (item of MostPopularPlaces; track item) {
          <div [ngClass]="[item.ColumnSpan]">
            <!-- Image Box -->
            <a [routerLink]="'/property'" class="img-box" [style.background-image]="'url(' + item.ImageUrl + ')'"
              [style.background-size]="'cover'">
              <div class="img-box-content visible">
                <h4>{{item.City}} </h4>
                <span>{{item.PropertiesCount}}</span>
              </div>
            </a>
          </div>
        }
      </div>
    </div>
  </section>
}
@if (WhatOurClientSays != undefined && WhatOurClientSays.length != 0) {
  <section
    class="fullwidth margin-top-20 margin-bottom-0 padding-bottom-20 padding-top-20" data-background-color="#f7f7f7">
    <h3 class="headline-box">What Our Users Say</h3>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="testimonials-subtitle">
            We collect reviews from our customers so you can get an honest
            opinion of How our portal affect peoples lives with pride and diginity on daily basis!
          </div>
        </div>
        @for (item of WhatOurClientSays; track item) {
          <div class="col-md-4">
            <div class="testimonial-box">
              <div class="testimonial">{{item.Testimonial}}</div>
              <div class="testimonial-author">
                <img [src]="item.Image" alt="User testimonial" loading="lazy">
                <h4>{{item.Author}} <span>{{item.Experience}}</span></h4>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}
